import React, { FC, useCallback } from 'react';
import { reduxForm, WrappedFieldProps, Field, getFormValues } from 'redux-form';
import {
  REPORT_OFFER_FORM_NAME,
  ReportOfferFormFields,
  ReportOfferFormValues,
} from './report-offer-form.logic';
import { FormContainer } from 'components/form-container/form-container';
import { map } from 'lodash';
import { Text } from 'components/text/Text';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { ReportOfferReason } from 'logic/api-models/report-offer';
import { Stack } from 'components/stack/stack';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useInProgress } from 'logic/store/tracker/tracker.hooks';
import { offerSlice } from 'logic/store/offer/offer.slice';
import { colors } from 'styles/colors';
import { useParams } from 'react-router-dom';
import { ReasonRadioInput } from './reason-radio.input';
import { ReportOfferButton } from './report.button';
import { Radio } from 'antd';

const Title = styled(Text)`
  color: ${colors.grayText};
  margin-bottom: 20px;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
`;

const ReportOffer: FC = () => {
  const isReportingInProgress = useInProgress(offerSlice.actions.reportOffer);
  const dispatch = useDispatch();
  const { id } = useParams<{ id: string }>();
  const formValues: ReportOfferFormValues | undefined = useSelector(
    getFormValues(REPORT_OFFER_FORM_NAME)
  );

  const handleReportOffer = useCallback(
    () =>
      formValues?.reason &&
      dispatch(offerSlice.actions.reportOffer({ offerId: id, reason: formValues.reason })),
    [dispatch, formValues]
  );

  const isReportButtonDisabled = isReportingInProgress || formValues?.reason === undefined;

  return (
    <FormContainer inProgress={isReportingInProgress}>
      <TitleContainer>
        <Title size={28}>{translate(translationKeys.reportOffer.title1)}</Title>
        <Title size={28}>{translate(translationKeys.reportOffer.title2)}</Title>
      </TitleContainer>
      <Stack flow={'row'} gap={2}>
        <Field
          name={ReportOfferFormFields.Reason}
          component={(props: WrappedFieldProps) => (
            <Radio.Group
              value={formValues?.reason}
              onChange={(e) => props.input.onChange(e.target.value)}
            >
              <Stack flow={'row'} gap={1}>
                {map(ReportOfferReason)
                  .filter((reason) => typeof reason === 'number')
                  .map((reason) => (
                    <ReasonRadioInput
                      reason={reason as ReportOfferReason}
                      key={reason}
                      {...props}
                    />
                  ))}
              </Stack>
            </Radio.Group>
          )}
        />
        <ReportOfferButton
          onClick={handleReportOffer}
          disabled={isReportButtonDisabled}
          loading={isReportingInProgress}
        />
      </Stack>
    </FormContainer>
  );
};

export const ReportOfferForm = reduxForm({
  form: REPORT_OFFER_FORM_NAME,
  destroyOnUnmount: true,
})(ReportOffer);
